import React, { lazy, Suspense, useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

import { ThemeContextProvider } from '../theme';
import FullPageLoadingIndicatorContainer from '../../components/fullPageLoadingIndicator/fullPageLoadingIndicatorContainer';
import { supportedBrowsersService } from './supportedBrowserService';
import CookiePanel from '../cookiePanel';
import { DateLocaleContextProvider } from '../../environment/context';

const App = lazy(() => import('../app/app'));
const UnsupportedApp = lazy(() => import('../unsupportedBrowserApp/unsupportedBrowserApp'));
const ModalDialogContainer = lazy(() => import('../../components/dialogManager/modalDialogContainer'));
const renderLoader = (): React.ReactElement => <FullPageLoadingIndicatorContainer size={90} />;

function BrowserBaseApp(): React.ReactElement {
  const [isBrowserSupported, setIsBrowserSupported] = React.useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    const isBrowserSupportedResult = supportedBrowsersService().isBrowserSupported();
    setIsBrowserSupported(isBrowserSupportedResult);
  }, []);

  useEffect(() => {
    console.log(`Location changed: ${location}`);
    ReactGA.send({ hitType: 'pageview', page: location.pathname, path: location.pathname });
  }, [location.pathname]);

  const childrenComponent = isBrowserSupported ? <App /> : <UnsupportedApp />;
  console.log('BrowserBaseApp render');

  return (
    <Suspense fallback={renderLoader()}>
      <ThemeContextProvider>
        <DateLocaleContextProvider>
          <CssBaseline />
          <ModalDialogContainer />
          <FullPageLoadingIndicatorContainer size={90} />
          {childrenComponent}
          <CookiePanel />
        </DateLocaleContextProvider>
      </ThemeContextProvider>
    </Suspense>
  );
}

export default BrowserBaseApp;
